import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=8b455c5c&scoped=true&"
import script from "./Water.vue?vue&type=script&lang=js&"
export * from "./Water.vue?vue&type=script&lang=js&"
import style0 from "./Water.vue?vue&type=style&index=0&id=8b455c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b455c5c",
  null
  
)

export default component.exports